import React, { useMemo, useEffect, useState } from 'react';
import {
    Grid,
    GridCellProps,
    GridRowProps,
    GridColumn as Column,
    GridToolbar,
    GridItemChangeEvent,
    GridNoRecords
  } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Icon } from '@iconify/react';
import * as Utils from '../../../../utils/EllowUtils';
import Styles from "../../styles.module.scss";
import DashboardHeader from "../../dashboardHeader";
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import Headline6 from "../../../../components/headings/Headline6"; 
import Button from "../../../../components/button"; 
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import TimeSheetSubmit from '../../../../modals/timesheetSubmit';
import { useLocation } from 'react-router-dom';
import { extractTimesheetDownload, timesheetDetails, updateTimeSheet } from './services';
import classnames from "classnames";
import Fields from '../../../../components/field';
import { Error } from "@progress/kendo-react-labels"; 

interface Product {
  workHoursCount: string;
  dayStatus: string;
  entryDate: string,
  entryDay: string,
}

interface Props {
OnSubmit?: any,
loginId?: string | null
}

interface CellRenderProps {
  originalProps: GridCellProps;
  td: React.ReactElement<HTMLTableCellElement>;
  enterEdit: (dataItem: Product, field: string | undefined) => void;
  editField: string | undefined;
}

interface RowRenderProps {
  originalProps: GridRowProps;
  tr: React.ReactElement<HTMLTableRowElement>;
  exitEdit: () => void;
  editField: string | undefined;
}

export const CellRender = (props: CellRenderProps) => {
  const dataItem = props.originalProps.dataItem;
  const cellField = props.originalProps.field;
  const inEditField = dataItem[props.editField || ""];
  const additionalProps = cellField && cellField === inEditField ? {
    ref: (td: any) => {
      const input = td && td.querySelector("input");
      const activeElement = document.activeElement;
      if(
          !input ||
          !activeElement ||
          input === activeElement ||
          !activeElement.contains(input)
        ){
          return;
        }
        if(input.type === "checkbox") {
          input.focus();
        }else{
          input.select();
        }
    }
  }
  :{
    onClick: () => {
      props.enterEdit(dataItem, cellField);
    }
  }

  const clonedProps: any = { ...props.td.props, ...additionalProps };
    return React.cloneElement(props.td, clonedProps);
  }

export const RowRender = (props: RowRenderProps) => {

  const weekdays = props.originalProps.dataItem.entryDay === 'Saturday' || props.originalProps.dataItem.entryDay === 'Sunday'
  const green = "holiday";
  const red = "weekday";
  const trProps: any = { className: weekdays ? green : red };
  return React.cloneElement(props.tr, { ...trProps });
}

const Avilability: React.FC<Props> = ({
}) => {

  let query: any = window.location.href
  let urlParams: any = new URL(query)
  let timesheetId: any = urlParams.search.slice(13,49)
  let projectId: any = urlParams.search.slice(60)

  const [selected, setSelected] = React.useState<number>(0);
  const { v4: uuidv4 } = require("uuid")
  const loginId = localStorage.getItem('loginId') 
  const value: any = useLocation().state
   
  const EDIT_FIELD = "inEdit";
 
  const [name, setName] = useState<string>('')
  const [tablearray, setTableArray] = useState<Array<Product>>([])
  const [startDate, setStartDate] = useState<any>()
  const [endDate, setEndDate] = useState<any>()
  const [data, setData] = React.useState<Array<Product>>(tablearray);
  const [changes, setChanges] = React.useState<boolean>(false);
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false)
  const [projectDetails, setProjectDetails] = useState<any>()
  const [candidateData , setCandidateData] = useState<{timesheet_id: string,project_id: string,candidate_name: string , company_name: string , project_name: string , designation: string , start_date: string, end_date: string, timesheet_status: string, submitted_on: any, month_holidays: any}>({timesheet_id: '',project_id: '',  candidate_name: '', company_name: '', project_name: '',designation: '', start_date: '',end_date:'', timesheet_status: '', submitted_on: '', month_holidays: ''})
  const [overTime, setOvertime] = useState<string>('')
  const [error, setError] = useState<string>('');
  const [modalData, setModalData] = useState<any>()
  const [leaveAllowed, setLeaveAllowed] = useState<boolean>(false)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [disableModalbtn, setDisableModalbtn] = useState<boolean>(false)

  const enterEdit = (dataItem: Product, field: string | undefined) => {
    const newData = data.map((item) => ({
      ...item,
      [EDIT_FIELD]: item.entryDate === dataItem.entryDate ? field : ''
    }));      
    setData(newData);
  };


  useEffect(() => {

      getSheetDetails(timesheetId, projectId)

  }, [])
  

  const getSheetDetails = (timeSheetId: string, projectId: string) => {
    
    timesheetDetails(timeSheetId, projectId).then((response) => {
      if (response && response.status === 1) {
        setCandidateData(response.data[0].timesheetDetails[0])
        setProjectDetails(response.data[0].projectDetails[0])
        getDaysArray(parseInt(response.data[0].timesheetDetails[0].start_date),parseInt(response.data[0].timesheetDetails[0].end_date))
        setStartDate(parseInt(response.data[0].timesheetDetails[0].start_date))
        setEndDate(parseInt(response.data[0].timesheetDetails[0].end_date))
        setLeaveAllowed(response.data[0] && response.data[0].projectDetails[0] && response.data[0].projectDetails[0].paymentSettings && response.data[0].projectDetails[0].paymentSettings.companyPaidLeaveAllowed)
        setDisabled(response.data[0] && response.data[0].timesheetDetails[0].timesheet_status === '1' ? false : true)
        if (response.data[0].timesheetEntries && response.data[0].timesheetEntries.length > 0) {
          let entries = response.data[0].timesheetEntries && response.data[0].timesheetEntries.map((item: any) => {
            return (
              {
                entryDate: new Date(parseInt(item.entry_date)).toDateString().slice(3),
                entryDay: item.entry_day,
                workHoursCount: item.workhours_count,
                workDescription: item.work_description,
                dayStatus: item.day_status,
                timesheetEntryId: item.timesheet_entry_id
               }
             )
           })            
           setData(entries)
         }
      }
     })
  }

  const exitEdit = () => {
    const newData = data.map((item) => ({ ...item, [EDIT_FIELD]: undefined }));
    setData(newData);
  };
  

  const saveChanges = (value: any, name: string) => {

    setDisableModalbtn(true)
    let emails = value && value.emailIds && value.emailIds.split(',')
    tablearray.splice(0, tablearray.length, ...data);
    setChanges(false);
    let timeSheetEntry: any = tablearray && tablearray.map((item: any) => {
      return (
        {
         
          "timesheetEntryId": item.timesheetEntryId ? item.timesheetEntryId  : uuidv4(),
          "entryDay": item.entryDay,
          "entryDate": Utils.getMilliSecUTC(item.entryDate),
          "workHoursCount": item.workHoursCount ? parseInt(item.workHoursCount) : 0,
          "workDescription": item.workDescription ? item.workDescription : '',
          "dayStatus": item.dayStatus ? item.dayStatus : '',
        }
      )
    })


    let body = {
        "action": name,
        "submittedBy": "FREELANCER",
        "loginId": loginId,
        "candidateName": candidateData && candidateData.candidate_name,
        "projectName": candidateData && candidateData.project_name,
        "companyName": candidateData && candidateData.company_name,
        "timesheetId":  candidateData.timesheet_id,
        "projectId": candidateData.project_id,
        "jobRole": candidateData.designation,
        "startDate": parseInt(candidateData && candidateData.start_date),
        "endDate": parseInt(candidateData && candidateData.end_date),
        "totalWorkingDays": checkTotalWorkingDays(),
        "actualWorkingDays": findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave'))),   
        "actualWorkingHours": calcTotalworkingHours(data),
        "holidays": leaveAllowed ?  data.filter(element => (element.dayStatus === 'Holiday')).length : candidateData && candidateData.month_holidays,
        "compOff": data.filter(element => (element.dayStatus === 'Compensation off')).length,
        "compOffWorking": data.filter(element => (element.dayStatus === 'Working for compensation')).length,
        "leaves": checkLeaves(data),
        "timesheetEntries": timeSheetEntry,
        "overtime": overTime ? parseFloat(overTime) : 0,
      "submittedTo": emails,
      "reportingManagerName": projectDetails.reportingManagerName,
      "reportingManagerEmail": projectDetails.reportingManagerEmail
      }
    
    updateTimeSheet(body).then((response) => {
      if (response && response.status == 1) {
        setShowSubmitModal(false)
        setDisableModalbtn(false)
        let body = {
          timesheet_id: candidateData.timesheet_id
        }
        extractTimesheetDownload(body)
        }
      })
  };

  const itemChange = (event: GridItemChangeEvent) => {
    setError('')
    let field = event.field || "";
    event.dataItem[field] = event.value;
    let newData = data.map((item) => {
      if (item.entryDate === event.dataItem.entryDate) {
        // item[field] = event.value;
      }
      return item;
    });
    setData(newData);
    setChanges(true);
  };

  const customCellRender: any = (
    td: React.ReactElement<HTMLTableCellElement>,
    props: GridCellProps
  ) => (
    <CellRender
      originalProps={props}
      td={td}
      enterEdit={enterEdit}
      editField={EDIT_FIELD}
    />
  );

  const customRowRender: any = (tr: React.ReactElement<HTMLTableRowElement>, props: GridRowProps) => (
    <RowRender
      originalProps={props}
      tr={tr}
      exitEdit={exitEdit}
      editField={EDIT_FIELD}
    />
    
  );

  const days = ['Sunday', 'Monday', 'TuesDay', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const dateChange = (e: any, name: string) => {
      if (name === 'startDate'){
          setStartDate(Utils.getMilliSecUTC(e.target.value))
      }else{
          setEndDate(Utils.getMilliSecUTC(e.target.value))
      }
      calcDiff();
      getDaysArray(startDate, endDate)
  }

  const checkDate = (value: string) => {
      
      switch(value){
          case 'Saturday':
              return 'Weekend'
          case 'Sunday':
              return 'Weekend'
          default:
              return ''
      }
  }

  var getDaysArray = function (start: any, end: any) {
    
      for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
          arr.push({'entryDate':  Utils.convertMilliSecToDateNew(dt), 'entryDay': days[dt.getDay()], 'dayStatus': checkDate(days[dt.getDay()]), 'workHoursCount': ''});
      }
      setData(arr)
      setTableArray(arr)     
      return arr;

      
  };

  const calcDiff = () => {       
      if (startDate && endDate){
          const oneDay = 24 * 60 * 60 * 1000;
          const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));   
      }
  }

  const checkLeaves = (data: any) => {      
    let count = 0
    data && data.map((item: any, key: number ) => {
      if(leaveAllowed){
        
        if(item.dayStatus === 'Half day'){
          if(item.workHoursCount <= 4 && item.workHoursCount > 0){
            count = count + 1
          }else{
            count = count + 0.5
          }
        }else if(item.dayStatus === 'Full day leave'){
          count = count + 1
        }else if(item.dayStatus === 'Holiday'){
          count = count
        }
        else if(item.workHoursCount >= 8){
          count = count 
        }else if(item.workHoursCount <= 8 && item.workHoursCount >= 4){
          count = count + 0.5
        }else if(item.workHoursCount <= 4 && item.workHoursCount > 0){       
          count = count + 1
        }
      }else{
        if(item.dayStatus === 'Half day'){
          if(item.workHoursCount <= 4 && item.workHoursCount > 0){
            count = count + 1
          }else{
            count = count + 0.5
          }
        }else if(item.dayStatus === 'Full day leave'|| item.dayStatus === 'Holiday'){
          count = count + 1
        }else if(item.workHoursCount >= 8){
          count = count 
        }else if(item.workHoursCount <= 8 && item.workHoursCount >= 4){
          count = count + 0.5
        }else if(item.workHoursCount <= 4 && item.workHoursCount > 0){       
          count = count + 1
        }
      }
    })
    return count
  }

  const calcTotalworkingHours = (data: any) => {
    let hours = 0
     data && data.map((item: any) => {
      hours = hours + Number(item.workHoursCount)
    })
    return hours
  }

  const monthNumber = new Date(startDate).getMonth()
  const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  let presentMonth = months[monthNumber]

  const checkTotalWorkingDays = () => {
    let d = new Date(parseInt(candidateData && candidateData.start_date))
    let y = d.getFullYear()
    let m = d.getMonth() + 1
    let days = new Date( y, m, 0 ).getDate();
    let sat = new Array();   //Declaring array for inserting Saturdays
    let sun = new Array(); 
    for(var i=1;i<=days;i++){    //looping through days in month
      var newDate = new Date(d.getFullYear(),d.getMonth(),i)
      if(newDate.getDay()==0){   //if Sunday
          sun.push(i);
      }
      if(newDate.getDay()==6){   //if Saturday
          sat.push(i);
      }
  }
  let holidays = candidateData && candidateData.month_holidays ? candidateData && candidateData.month_holidays : 0
  let val = days - (sun.length + sat.length) - holidays
  return val
  
  }

  const findActualCount = (data: any) => {
    let count = 0    
    data && data.map((item: any, key: number) => {
      if(item.dayStatus === 'Half day leave'){
        if(item.workHoursCount >= 4){
          count = count + 0.5
        }
      }else if(item.dayStatus === 'Compensation off'){
        count = count + 1
      }else if(item.dayStatus === 'Half day compensation off'){
        if(item.workHoursCount >= 8){
          count = count + 1
        }else if(item.workHoursCount < 8 && item.workHoursCount >= 4){
          count = count + 1
        }else if(item.workHoursCount <= 4){
          count = count + 0.5
        }
      }else if (leaveAllowed){
         if(item.dayStatus === 'Working'){
          if(item.workHoursCount >= 8){
            count = count + 1
          }else if(item.workHoursCount <= 8 && item.workHoursCount >= 4){
            count = count + 0.5
          }else if(item.workHoursCount <= 4){
            count = count + 0
          }
        }
      }else if(!leaveAllowed){
         if(item.dayStatus === 'Working'){
          if(item.workHoursCount >= 8){
            count = count + 1
          }else if(item.workHoursCount <= 8 && item.workHoursCount >= 4){
            count = count + 0.5
          }else if(item.workHoursCount <= 4){
            count = count + 0
          }
        }
      }
    })
    return count
  }

  const saveTimesheet = () => {
    let today = new Date().toDateString()
    let array = data
    let length = data.length
    // if (today === array[length - 2].entryDate){
      let validData = data && data.filter(element => (element.entryDay !== 'Saturday' && element.entryDay !== 'Sunday' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave'))
      let check:any = validData && validData.length > 0 && validData.map((item: any) => {
        return (
        (item.workHoursCount !== '0' && item.dayStatus !== '') ?
        true : false
        )
      })
  
    if (check.includes(false)) {
      setError('Complete the timesheet before submitting')
      setShowSubmitModal(false)
    }
    else {
      setDisabled(true)
      setShowSubmitModal(true);
      setName('submit')
      let calculations = {
        totalWorkingDays : checkTotalWorkingDays(),
        actualWorkingDays:findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave'))),
        actualWorkingHours: calcTotalworkingHours(data),
        holidays: leaveAllowed ?  data.filter(element => (element.dayStatus === 'Holiday')).length : candidateData && candidateData.month_holidays,
        compOff: data.filter(element => (element.dayStatus === 'Compensation off')).length,
        HalfDaycompOff: data.filter(element => (element.dayStatus === 'Half day compensation off')).length,
        leaves: checkLeaves(data),
        overtime: overTime,
      }
      setModalData({...modalData, calculations})
    }
    // }else{
    //   setError('You can submit 2 days before timesheet ends')
    // }
  }



return (
      <div className={Styles.timesheetWrapper}>
            <div className={classnames(Styles.timesheetContent, "contentBox mb-40")}>
              <div className="innerPadd24">
              <div className={Styles.timesheetheadWapper}>
                <div className={Styles.timesheetHead}>
                  {candidateData.candidate_name} - <span> {candidateData.designation} </span>
                </div>
                <div className={Styles.timesheetSubHead}>
                  {new Date(startDate).toDateString()} - {new Date(endDate).toDateString()}
                </div>
              </div>
              <div className="tableStyle no-padd-top no-min-height">
                <Grid
                    data={data}
                    dataItemKey={"ProductID"}
                    rowHeight={50}
                    onItemChange={itemChange}
                    cellRender={customCellRender}
                    rowRender={customRowRender}
                    editField={EDIT_FIELD}
                >
            <GridNoRecords>
              <div className="noData">
                <Icon icon="mdi:smiley-neutral-outline" />
                No data to display
              </div>
            </GridNoRecords>
                    <Column field="entryDate" title="Date" cell={(props: GridCellProps) => companyName(props)} editable={false}/>
                    <Column field="entryDay" title="Day" editable={false}/>
                    <Column field="workHoursCount" title="No.of working Hrs." />
                    <Column field="workDescription" title="Work Description" />
                    {/* <Column field="dayStatus" title="Status" /> */}
                    <Column field="dayStatus" title="status" cell={(props: GridCellProps) => DropDown(props)}/>
                </Grid>
              </div>
              <div className={Styles.totalInfo}>
                  <div className={Styles.cardItremWrap}>
                    <div className={Styles.cardItrem}>
                        <div className={Styles.form}>
                    <label>Total working days in this month:</label>
                    {checkTotalWorkingDays()}
                    {/* {data.filter(element => (element.entryDay !== 'Saturday' && element.entryDay !== 'Sunday' && element.dayStatus !== 'Holiday')).length} */}
                        </div>
                        <div className={Styles.form}>
                    <label>Actual days worked:</label>
                    {findActualCount(data.filter(element => (element.dayStatus !== 'Weekend' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave')))}
                        </div>
                    </div>
                    <div className={Styles.cardItrem}>
                        <div className={Styles.form}>
                    <label>Holidays</label>
                    {leaveAllowed ?  data.filter(element => (element.dayStatus === 'Holiday')).length : candidateData && candidateData.month_holidays}
                        </div>
                        <div className={Styles.form}>
                    <label>Leaves: </label>
                    { checkLeaves(data)}
                        </div>
                    </div>
                    <div className={Styles.cardItrem}>
                        <div className={Styles.form}>
                          <label>Overtime</label>
                          <div className={classnames(Styles.otFiled, "form-group")}>
                            <Fields type='number' placeholder="" onChange={(e: any) => setOvertime(e.target.value)} value={overTime} 
                            disabled={candidateData && parseInt(candidateData.timesheet_status) > 1 && candidateData.submitted_on && candidateData.timesheet_status !== '4' ? true : false}
                            />
                          </div>
                        </div>
                    </div>
                    <div className={Styles.cardItrem}>
                        <div className={Styles.form}>
                          <label>Actual working hours:</label>
                          <div className="form-group"><span className={Styles.total}>{calcTotalworkingHours(data.filter(element => (element.entryDay !== 'Saturday' && element.entryDay !== 'Sunday' && element.dayStatus !== 'Holiday' && element.dayStatus !== 'Full day leave')))}</span></div>
                        </div>
                    </div>
                  </div>
                  <Error>{error}</Error>
                <div className={Styles.totalaction}>
                  <Button onClick={() =>saveTimesheet()} disabled={disabled} type="submit" variant="primary">Submit</Button>
                </div>
          {showSubmitModal && <TimeSheetSubmit onClose={() => setShowSubmitModal(false)} onSubmit={(data: any) => saveChanges(data, name)} projectDetails={projectDetails} candidateData={candidateData} modalData={modalData} submitButton={disableModalbtn}/>}   
              </div>
                      
              </div> 
          </div>
    </div>
  );
}

export default Avilability;

const companyName = (props: GridCellProps) => {
  return (
      <td>
          <div className="userInfo">
              {props.dataItem && props.dataItem.entryDate}
          </div>
  </td>
)
}

const DropDown = (props: GridCellProps) => {


  const handleChange = (e: DropDownListChangeEvent) => {
    if(props.onChange){
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value.text,
      });
    }
    
  }
  
  return (
      <td>
          { props.dataItem.inEdit ? <DropDownList
              style={{ width: "100%" }}
              onChange={handleChange}
              value={finddayStatus(props.dataItem.dayStatus)}
              data={[
                  { text: 'Holiday', id: 1 },
                  { text: 'Working', id: 2 },
                  { text: 'Half day', id: 3 },
                  { text: 'Full day leave', id: 4 },
                  { text: 'Compensation off', id: 5 },
                  { text: 'Working for compensation', id: 6 },
                  { text: 'Weekend', id: 7 }
              ]}
              textField="text"
          /> : props.dataItem.dayStatus}
      </td>
  )
  }

const finddayStatus = (value: any) => {
  switch(value){
    case 'Holiday':
      return { text: 'Holiday', id: 1 }
    case 'Working':
      return { text: 'Working', id: 2 }
    case 'Half day':
      return { text: 'Half day', id: 3 }
    case 'Full day leave':
      return { text: 'Full day leave', id: 4 }
    case 'Compensation off':
      return { text: 'Compensation off', id: 5 }
    case 'Working for compensation':
      return { text: 'Working for compensation', id: 6}
    case 'Weekend':
      return { text: 'Weekend', id: 7}
  }
  }